import { IOptionDealTeam } from "../components/EditDealTeam/types";

export const memberAlphabeticalSort = (list: IOptionDealTeam[]) => {
  return list.sort((a, b) => a.value.toLowerCase().localeCompare(b.value.toLowerCase()));
};
